import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  isQuery: false,
  queryFromCreatedDate: null,
  queryToCreatedDate: null,
  queryMessageType: '',
  queryMessageSubject: '',
  queryAuthor: '',
  queryMessage: '',
  isArchived: false,
  showFilters: false,
  radio: 'normal',
  messageTypes: [],
  messageSubjects: [],
  selectedConversation: null,
  toggle: false,
  conversations: [],
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'author',
      label: 'Author',
      aria: 'Author',
      sortable: true,
      searchable: true
    },
    {
      field: 'type',
      label: 'Type',
      aria: 'Type',
      sortable: true,
      searchable: true
    },
    {
      field: 'subject',
      label: 'Subject',
      aria: 'Subject',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      label: 'Created',
      date: true,
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    dateSelector: {
      display: 'flex',
      padding: '12px',
      textAlign: 'center',
      verticalAlign: 'middle',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
